import { Form, Select } from 'antd'
import { FC, useContext } from 'react'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'
import { useGetLacquerTypesQuery } from '../../../../../../store/api/lacquer-types-api'
import CalculationPosition from '../../../../../../types/api/calculation-position'

interface CalculationLacquersSelectProps {
    record?: CalculationPosition
}

const CalculationLacquersSelect: FC<CalculationLacquersSelectProps> = ({ record }) => {
    const ctx = useContext(EditableCellCtx)
    const form = useFormInstance()
    const { data } = useGetLacquerTypesQuery()
    const options = data?.data.map(x => ({
        value: x.documentId,
        label: x.name,
    }))

    const onBlur = () => {
        const selectedIds: string[] = form.getFieldValue('lacquers') ?? []
        const nameByType = new Map(
            (record?.lacquers ?? [])
                .filter(l => l.type?.documentId)
                .map(l => [l.type!.documentId, l.name || ''])
        )

        form.setFieldValue(
            'lacquers',
            selectedIds.map(id => ({ type: id, name: nameByType.get(id) ?? '' }))
        )
        ctx.onBlur()
    }

    return (
        <Form.Item name='lacquers' noStyle>
            <Select
                style={{ width: '100%' }}
                options={options}
                autoFocus
                defaultOpen
                onBlur={onBlur}
                popupMatchSelectWidth={180}
                mode='multiple'
                allowClear
            />
        </Form.Item>
    )
}

export default CalculationLacquersSelect
